import React, { useState } from 'react';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import { useLocation, useNavigate } from 'react-router-dom';
import { Snackbar, Alert, TextField, Button } from '@mui/material';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import Footer from 'examples/Footer';
import ProfileInfoCard from 'examples/Cards/InfoCards/ProfileInfoCard';
import Header from './components/Header';
import TopNavbar from 'examples/Navbars/TopNavbar';
import MDAlert from 'components/MDAlert';
import { apiGivePoint } from 'api/point.api';
import { useData } from '../../../hooks';

function Memberdetail() {
  const location = useLocation();
  const navigate = useNavigate();
  const { userdata } = location.state || {};
  const { user } = useData();

  const [showAlert, setShowAlert] = useState(false);
  const [pointType, setPointType] = useState('');
  const [pointValue, setPointValue] = useState('');
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  const handleEdit = () => {
    navigate(`/member/edit`, { state: { userdata, page: location.state.page, searchcond: location.state.searchcond } });
  };
  

  const handleAddPointClick = (type) => {
    setPointType(type);
    setShowAlert(true);
  };

  const handleConfirmAddPoint = async () => {
    const params = {
      userid: userdata.userid,
      rpoint: pointType === 'rpoint' ? pointValue : undefined,
      oldRpoint: pointType === 'oldRpoint' ? pointValue : undefined,
      mpoint: pointType === 'mpoint' ? pointValue : undefined,
    };
    
    try {
      const response = await apiGivePoint(params, user.accessToken);
      if (response === 'success') {
        setSnackbarMessage('포인트가 성공적으로 추가되었습니다.');
        setSnackbarSeverity('success');

        setTimeout(() => {
          navigate(`/members?page=${location.state.page}&searchcond=${location.state.searchcond}`);
        }, 500);
        
      } else {
        setSnackbarMessage('포인트 추가에 실패했습니다.');
        setSnackbarSeverity('error');
      }
    } catch (error) {
      setSnackbarMessage('포인트 추가 중 오류가 발생했습니다.');
      setSnackbarSeverity('error');
    } finally {
      setOpenSnackbar(true);
      setShowAlert(false);
      setPointValue('');
    }
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  return (
    <DashboardLayout>
      <TopNavbar />
      <MDBox mb={2} />
      <Header user={userdata?.name}>
        <MDBox mt={5} mb={3}>
          <Grid container spacing={1}>
            <Grid item xs={12} md={6} xl={4} sx={{ display: 'flex' }}>
              <Divider orientation="vertical" sx={{ ml: -2, mr: 1 }} />
              <ProfileInfoCard
                title="프로필"
                description={''}
                info={{
                  이름: userdata?.name,
                  전화: userdata?.phone,
                  이메일: userdata?.email,
                  아이디: userdata?.userid,
                  사용자타입: userdata?.userType,
                  r포인트: userdata?.rpoint,
                  구r포인트: userdata?.oldRpoint,
                  m포인트: userdata?.mpoint,
                  s포인트: userdata?.spoint,
                  포인트수령가능여부: userdata?.receivable === 1 ? '가능' : '불가',
                  기프티콘구매: userdata?.isGiftPurchaseLocked === true ? '차단' : '가능',
                  누적페트수량: userdata?.petcnt,
                  가입일: formatDate(userdata?.createdAt),
                  상태: userdata?.status,
                }}
                social={[]}
                action={{ route: '', tooltip: '정보수정', onClick: handleEdit }}
                shadow={false}
                onAddPoint={handleAddPointClick}
              />
            </Grid>
          </Grid>
        </MDBox>
      </Header>
      <Footer />
      {showAlert && (
        <MDAlert color="info" dismissible>
          <MDBox display="flex" flexDirection="column" alignItems="center">
            <MDTypography variant="h6">{pointType === 'rpoint' ? 'R포인트' : pointType === 'oldRpoint' ? '구 R포인트' : 'M포인트'} 추가</MDTypography>
            <TextField 
              label={pointType === 'rpoint' ? 'R포인트' : pointType === 'oldRpoint' ? '구 R포인트' : 'M포인트'} 
              value={pointValue} 
              onChange={(e) => setPointValue(e.target.value)} 
              margin="normal" 
              fullWidth 
              variant="outlined"
              InputProps={{ style: { backgroundColor: 'white' } }}
            />
          </MDBox>
          <MDBox display="flex" justifyContent="center" mt={2}>
            <Button variant="contained" color="success" onClick={handleConfirmAddPoint} style={{ marginRight: '10px' }}>
              저장
            </Button>
            <Button variant="contained" color="error" onClick={() => setShowAlert(false)}>
              취소
            </Button>
          </MDBox>
        </MDAlert>
      )}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </DashboardLayout>
  );
}

export default Memberdetail;
